import React, { useState, useEffect } from 'react';
import './App.css';
import DisclaimerPopup from './components/DisclaimerPopup';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TaglineBanner from './components/TaglineBanner';
import WhatsAppFloat from './components/WhatsAppFloat';
import ServiceAbout from './components/ServiceAbout';
import PracticeAreas from './components/PracticeAreas';
import Testimonials from './components/Testimonials';
import TrustSection from './components/TrustSection';
import MeetTheTeam from './components/MeetTheTeam';
import ReadyToServe from './components/ReadyToServe';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

function App() {
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  useEffect(() => {
    const hasAcceptedDisclaimer = localStorage.getItem('disclaimerAccepted');
    if (hasAcceptedDisclaimer) {
      setShowDisclaimer(false);
    }
  }, []);

  const handleAcceptDisclaimer = () => {
    localStorage.setItem('disclaimerAccepted', 'true');
    setShowDisclaimer(false);
  };

  return (
    <div className="App">
      {showDisclaimer && <DisclaimerPopup onAccept={handleAcceptDisclaimer} />}
      
      <Navbar />
      <Hero />
      <TaglineBanner />
      <PracticeAreas />
      <Testimonials />
      <TrustSection />
      <div id="team">
        <MeetTheTeam />
      </div>
      <ServiceAbout />
      <div id="blog">
        <ReadyToServe />
      </div>
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
      
      <Toaster />
    </div>
  );
}

export default App;